import { AlertTriangle } from 'lucide-react';
import styles from './FaqStatusBar.module.scss';

const FaqStatusBar = () => (
  <div className={styles.bar} role="status">
    <span><AlertTriangle aria-hidden="true" /> Rasuwa–Bhotekoshi flood — current travel information</span>
    <span>Last updated: 31 August 2026</span>
  </div>
);

export default FaqStatusBar;
